import { Delete, Tabs } from "../../shared";
import IccConfigForm from "./IccConfigForm";
import ViewIccConfig from "./ViewIccConfig";
import { DELETE_ICC_CONFIG, UPDATE_ICC_CONFIG } from "./query";
const SubComponent = ({ data }) => {
    const { id } = data;

    return (
        <Tabs
            tabItems={[
                {
                    id: `viewConfig${data.id}`,
                    name: "View",
                    content: <ViewIccConfig data={data} />,
                },
                {
                    id: `updateConfig${id}`,
                    name: "Update",
                    content: (
                        <>
                            <h5 className="mb-4">Update Veeva</h5>
                            <IccConfigForm
                                query={UPDATE_ICC_CONFIG}
                                formType="update"
                                formData={data}
                            />
                        </>
                    ),
                },
                {
                    id: `deleteConfig${id}`,
                    name: "Delete",
                    content: (
                        <Delete
                            title="ICC Config"
                            id={data.id}
                            query={DELETE_ICC_CONFIG}
                            cacheName="allIccEnvironmentConfigurations"
                        />
                    ),
                },
            ]}
        />
    );
};

export default SubComponent;
